import React from 'react';
import { X } from 'lucide-react';
import ModalBackdrop from './ModalBackdrop';

export default function ModalShell({
  children,
  icon: Icon,
  maxWidthClass,
  onClose,
  subtitle,
  themeClass,
  title
}) {
  return (
    <ModalBackdrop onClose={onClose} maxWidthClass={maxWidthClass}>
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-[28px] sm:rounded-3xl shadow-2xl overflow-hidden max-h-[calc(100vh-1rem)] sm:max-h-[calc(100vh-2rem)] flex flex-col">
        <div className={`px-4 sm:px-6 py-4 border-b border-gray-100 dark:border-gray-700 flex items-start justify-between gap-3 ${themeClass}`}>
          <div className="flex items-center gap-3 text-white min-w-0">
            {Icon ? <Icon size={20} /> : null}
            <div className="space-y-1 min-w-0">
              <h3 className="text-sm font-black uppercase tracking-tight">{title}</h3>
              {subtitle ? <p className="text-xs text-white/80 break-words">{subtitle}</p> : null}
            </div>
          </div>
          <button onClick={onClose} className="text-white/80 hover:text-white transition-colors shrink-0">
            <X size={20} />
          </button>
        </div>
        {children}
      </div>
    </ModalBackdrop>
  );
}
